import defineCustomElement from "./defineCustomElement.bea6.js"

defineCustomElement('md-oembed', (el) => {
  const url = el.dataset.url
  const oembed = new URL('/oembed', url)
  if(oembed.host === 'x.com') oembed.host = 'publish.twitter.com'
  oembed.search = new URLSearchParams({ url })
  const ac = new AbortController()
  const signal = ac.signal

  Promise.resolve()
    .then(() => windowLoadedAndIdle())
    .then(() => fetch(oembed, { signal, priority: 'low' }))
    .then((res) => res.json())
    .catch(() => loadScript(oembed, signal))
    .then(({ html }) =>  frameHtml(el, html, signal))
    .catch(console.warn)

  return () => ac.abort()
})

const windowLoadedAndIdle = () => new Promise((res, rej) => {
  document.readyState === 'complete' ? res() : window.addEventListener('load', res)
}).then(() => new Promise((res) => {
  window.requestIdleCallback?.(res) ?? res() // not on safari
}))

const loadScript = (url, signal) => new Promise((res, rej) => {
  const cb = `md_cb_${btoa(Math.random()).replaceAll('=','')}`
  url.searchParams.set('callback', cb)

  window[cb] = (d) => res(d)
  const script = document.createElement('script')
  script.src = url
  script.defer = 1
  script.addEventListener('load', window.cb)
  document.body.append(script)
  script.remove()
  signal.addEventListener('abort', rej)
})

const frameHtml = (el, html, signal) => {
  if(signal.aborted) return
  const iframe = document.createElement("iframe");
  iframe.style.width = '100%'
  iframe.loading = 'lazy'
  iframe.sandbox = "allow-scripts allow-same-origin"
  iframe.srcdoc =  ['<style>*{margin:0!important;font-family:sans-serif;padding:0}body{overflow:hidden}</style>',
    '\x3Cscript type="module" async>new ResizeObserver(() => { window.parent.postMessage(document.documentElement.scrollHeight, "*"); }).observe(document.documentElement)',
    '\x3C/script>', html].join('')
  el.appendChild(iframe)

  window.addEventListener("message", (e) => {
    if(signal.aborted) return // lazy, but fine for use case
    if(e.source === iframe.contentWindow && e.data > 0) iframe.style.height = `${e.data}px`;
  })
}
